import React from 'react'
import { Star, Quote } from 'lucide-react'

export default function ReviewCard({ review }) {
  const rating = review.rating || 5

  return (
    <div className="relative flex flex-col justify-between h-full rounded-2xl border border-amber-500/30 shadow-backlight-hover bg-zinc-900/60 md:shadow-backlight md:border-zinc-800/80 md:bg-zinc-900/40 md:hover:shadow-backlight-hover md:hover:border-amber-500/30 md:hover:bg-zinc-900/60 p-6 backdrop-blur-sm transition-all duration-300">
      {/* Quote Icon Background */}
      <div className="absolute right-6 top-6 text-zinc-800/40">
        <Quote className="h-8 w-8" />
      </div>

      <div>
        {/* Stars */}
        <div className="flex items-center gap-1 text-[#bb9b56]">
          {[...Array(5)].map((_, i) => (
            <Star
              key={i}
              className={`h-4 w-4 ${i < rating ? 'fill-[#bb9b56] text-[#bb9b56]' : 'text-zinc-700'}`}
            />
          ))}
        </div>

        {/* Review Text */}
        <p className="mt-4 text-sm text-zinc-300 italic leading-relaxed">
          "{review.text?.da || review.text}"
        </p>
      </div>

      {/* Author Details */}
      <div className="mt-6 border-t border-zinc-800/60 pt-4">
        <h4 className="text-sm font-bold text-white">{review.name}</h4>
        <div className="mt-1 flex flex-wrap items-center justify-between gap-2 text-xs text-zinc-500">
          <span>{review.event_type?.da || review.event_type}</span>
          <span>{review.date}</span>
        </div>
      </div>
    </div>
  )
}
